"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_player_addons_common_player_1 = require("@sky-uk-ott/client-lib-js-player-addons-common-player");
var WINRT_PLAYER_STATES_MAP = {
    buffering: client_lib_js_player_addons_common_player_1.PlayerState.Rebuffering,
    finished: client_lib_js_player_addons_common_player_1.PlayerState.Finished,
    paused: client_lib_js_player_addons_common_player_1.PlayerState.Paused,
    playing: client_lib_js_player_addons_common_player_1.PlayerState.Playing,
    stopped: client_lib_js_player_addons_common_player_1.PlayerState.Stopped,
    error: client_lib_js_player_addons_common_player_1.PlayerState.Stopped,
};
function getPlayerState(winRtPlayerState) {
    if (WINRT_PLAYER_STATES_MAP[winRtPlayerState] !== undefined) {
        return WINRT_PLAYER_STATES_MAP[winRtPlayerState];
    }
    return undefined;
}
exports.getPlayerState = getPlayerState;
